import { render, staticRenderFns } from "./Grid123.vue?vue&type=template&id=6c3c54b4"
import script from "./Grid123.vue?vue&type=script&lang=js"
export * from "./Grid123.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports